<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Downloadbaar Excel-bestand met de data
  </div>
</template>

<script>
export default {
  name: 'CsvExport',
};
</script>
